import React from 'react'
import { useSky, setScene, SCENES } from '../hooks/useSky'

const NAMES = { bay: 'The Bay', desert: 'Sonoran desert', forest: 'Sierra forest' }

const ICONS = {
  bay: (
    <>
      <path d="M2 16h20" />
      <path d="M7 16V7M17 16V7" />
      <path d="M2 14.5C4.5 9 7 7 7 7s3.6 6.5 5 6.5S17 7 17 7s2.5 2 5 7.5" />
    </>
  ),
  desert: (
    <>
      <path d="M12 21V5" />
      <path d="M12 13H8.5V8" />
      <path d="M12 11h3.5V7" />
    </>
  ),
  forest: (
    <>
      <path d="M12 3 7 10h2.5L6 15.5h5V21" />
      <path d="M12 3l5 7h-2.5l3.5 5.5H13V21" />
    </>
  ),
}

// Scene picker in the masthead: one icon per landscape, the current one filled in.
const SceneSwitch = () => {
  const sky = useSky()
  const current = (sky && sky.scene) || 'bay'
  return (
    <div className="scene-switch" role="group" aria-label="Scene">
      {SCENES.map((name) => (
        <button
          key={name}
          type="button"
          aria-pressed={current === name}
          aria-label={NAMES[name]}
          title={NAMES[name]}
          onClick={() => setScene(name)}
        >
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
            {ICONS[name]}
          </svg>
        </button>
      ))}
    </div>
  )
}

export default SceneSwitch
